/* eslint-disable react/no-unknown-property */
/* eslint-disable react/require-default-props */
import React from 'react';

export const DialerRecordEnable = ({
  width = 24,
  height = 24,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 12.5075C12.2761 12.5075 12.5 12.2836 12.5 12.0075C12.5 11.7313 12.2761 11.5075 12 11.5075C11.7239 11.5075 11.5 11.7313 11.5 12.0075C11.5 12.2836 11.7239 12.5075 12 12.5075Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 12.5075C12.2761 12.5075 12.5 12.2836 12.5 12.0075C12.5 11.7313 12.2761 11.5075 12 11.5075C11.7239 11.5075 11.5 11.7313 11.5 12.0075C11.5 12.2836 11.7239 12.5075 12 12.5075ZM10.5 12.0075C10.5 11.1791 11.1716 10.5075 12 10.5075C12.8284 10.5075 13.5 11.1791 13.5 12.0075C13.5 12.8359 12.8284 13.5075 12 13.5075C11.1716 13.5075 10.5 12.8359 10.5 12.0075Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22C6.47715 22 2 17.5229 2 12Z"
      fill="currentColor"
    />
    <circle cx="12" cy="12" r="5" fill="currentColor" />
  </svg>
);
